module.exports = __webpack_public_path__ + "static/img/sm-bt.8dfb1ce5.png";